import { t } from 'i18next'

import { TimeTrackingTab } from './const'

const ALL_TABS = [
  { id: TimeTrackingTab.MY_TIMES, titleKey: 'timeTracking.tabs.myTimes' },
  { id: TimeTrackingTab.MY_TEAM, titleKey: 'timeTracking.tabs.myTeam' },
  { id: TimeTrackingTab.MY_ORDERS, titleKey: 'timeTracking.tabs.myOrders' },
  { id: TimeTrackingTab.ALL_TIMES, titleKey: 'timeTracking.tabs.allTimes' },
]

export const timeTrackingTabTitles = () =>
  ALL_TABS.map((tab) => ({ id: tab.id, title: t(tab.titleKey) }))
